<div style="text-align: right;color:#004976;font-weight: 600;font-size: 12px;padding:10px;margin-right:20px;margin-top:10px;margin-bottom:10px;position: absolute;
    right: 10px;" *ngIf="selectedType !== 'cluster' && selectedType !== 'factory' && selectedType !== 'sku'">
    <em class="fa fa-info-circle"></em> &nbsp;
    Stock Adjusted value are not available at this level
</div>
<div class="stacked-bar-chart-wrapper fw fh">

    <div class="no-data-top"
        *ngIf="!(plotData && plotData?.length > 0 && plotData[0].quantity &&  plotData[0].quantity.length > 0 && plotData[0].quantity[0].qty && plotData[0].quantity[0].qty.length > 0)">

    </div>

    <div *ngIf="plotData && plotData?.length > 0 && plotData[0].quantity &&  plotData[0].quantity.length > 0 && plotData[0].quantity[0].qty && plotData[0].quantity[0].qty.length > 0"
        class="stacked-bar-chart-cntnr fw fh">

        <div class="top">
            <div class="top-left">


                <div class="line-type-radio-wrapper">
                    <mat-radio-group [(ngModel)]="lineNameType" *ngIf="plotData[0].type==='Line'">
                        <mat-radio-button class="line-radio-button fw {{type.class}}" *ngFor="let type of lineType"
                            [value]="type" title="{{type?.translateCode | translate}}">
                            {{type?.translateCode | translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div class="top-right">
                <div class="line-not-config" *ngIf="plotData[0].type==='Line'">

                    <span hidden class="not-config-label">{{'waste_db.line_not_configured' | translate}}</span>
                </div>
                <div class="unit-legend">
                    <span class="value-label" title="{{'common.units' | translate}}">
                        <span class="value-label-unit">{{'common.units' | translate}}</span>:
                    </span>
                    <span class="legend-value-conainer">
                        <span class="value">
                            <div class="box-ton"></div>{{'common.Tons' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-kilos"></div>{{'common.KG' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-litre"></div>{{'common.L' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-m"></div>{{'common.M' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-st"></div>{{'common.ST' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-ea"></div>
                            {{'common.EA' | translate}}/{{'common.PC' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-g"></div>{{'common.G' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-ml"></div>{{'common.ML' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-m2"></div>{{'common.M2' | translate}}/{{'common.FT' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-km"></div>{{'common.KM' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-zke"></div>{{'common.ZKE' | translate}}/{{'common.GLL' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-th"></div>{{'common.TH' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-cs"></div>{{'common.CS' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-rol"></div>{{'common.ROL' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-pwd"></div>{{'common.PWD' | translate}}/{{'common.OZA' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-mm"></div>{{'common.MM' | translate}}/{{'common.M3' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-lb"></div>{{'common.LB' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-dz"></div>{{'common.DZ' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-cj"></div>{{'common.CJ' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-cm"></div>{{'common.CM' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-to"></div>{{'common.TO' | translate}}
                        </span>
                        <span class="value">
                            <div class="box-tc"></div>{{'common.TC' | translate}}/{{'common.PCO' | translate}}
                        </span>
                    </span>
                </div>
            </div>
        </div>

        <div class="y-axis-label fh">
            <div class="y-label">
                <span>
                    {{'waste_db.waste_quantity' | translate}}
                </span>
            </div>
        </div>

        <div class="bar fh" [ngClass]="{ first: first, last: last }"
            *ngFor="let currentplotData of plotData; let first = first; let last = last;let i=index;">

            <div class="bar-split">

                <div class="bar-inner"
                    *ngFor="let quantityArr of currentplotData.quantity; let first = first; let last = last;let j=index;"
                    triggers="mouseenter:mouseleave" (mouseleave)="hoveredItem=null" [style.height]="quantityArr?.componentTotal>0?(showTotalForBar?((quantityArr?.total*100)/yScaleMax)+'%' :
                    ((quantityArr?.componentTotal*100)/yScaleMax)+'%'):'0%'" (click)="onBarClick(currentplotData)"
                    (mouseenter)="hoveredItem=i" [popover]="popTemplate" container="body"
                    containerClass="multi-bar-popup" placement="auto" @fillUp (keydown)="onBarClick(currentplotData)"
                    (keypress)="onBarClick(currentplotData)" (keyup)="onBarClick(currentplotData)">

                    <div class="component fw" *ngFor="let component of quantityArr.qty" [ngClass]="component?.unit"
                        [style.height]="showTotalForBar?((component?.value*100)/quantityArr?.total)+'%' : ((component?.value*100)/quantityArr?.componentTotal)+'%'">
                        <div class="component-value fw">
                        </div>
                    </div>
                    <div class="total-value  fw" *ngIf="showTotalForBar"
                        title="{{quantityArr?.total | sbValFormat : yRange}}">
                    </div>
                    <div class="x-type-label fw ellipses" title="{{quantityArr?.type}}">
                        <span>{{quantityArr?.type}}</span>
                    </div>
                </div>
            </div>
            <div class="x-label fw"
                [ngClass]="{'not-configured' : (currentplotData.type==='Line' && currentplotData.isLinesMapped===false)}">
                <div class="ellipses bar-name"
                    [ngClass]="{'bar-name-color' : (currentplotData.type==='Line' && currentplotData.isLinesMapped===false)}">
                    <span *ngIf="currentplotData.type !=='Line'" title="{{currentplotData?.name}}">
                        {{selectedType === 'sku' || selectedType === 'linetosku' ? currentplotData?.id + ' - ' +
                        currentplotData?.name : currentplotData?.name}}
                    </span>
                    <span *ngIf="currentplotData.type ==='Line' && lineNameType.name === 'Local Name'"
                        title="{{currentplotData?.lineLocalName}}">
                        {{currentplotData?.lineLocalName}}
                    </span>
                    <span *ngIf="currentplotData.type ==='Line' && lineNameType.name === 'Manex Name'"
                        title="{{currentplotData?.lineManexName}}">
                        {{currentplotData?.lineManexName}}
                    </span>
                    <span *ngIf="currentplotData.type ==='Line' && lineNameType.name === 'SAP Name'"
                        title="{{currentplotData?.lineSAPName}}">
                        {{currentplotData?.lineSAPName}}
                    </span>
                </div>
                <div class="config-error-container"
                    *ngIf="currentplotData.type==='Line' && currentplotData.isLinesMapped===false">
                </div>
            </div>



            <ng-template #popTemplate>
                <div class="fw popup-quantity fh">

                    <div class="header">
                        <span *ngIf="selectedType !== 'line'">
                            {{popOverArr[hoveredItem]?.name}}
                        </span>
                        <span *ngIf="selectedType === 'line' && lineNameType.name === 'Local Name'">
                            {{popOverArr[hoveredItem]?.lineLocalName}}
                        </span>
                        <span *ngIf="selectedType === 'line' && lineNameType.name === 'Manex Name'">
                            {{popOverArr[hoveredItem]?.lineManexName}}
                        </span>
                        <span *ngIf="selectedType === 'line' && lineNameType.name === 'SAP Name'">
                            {{popOverArr[hoveredItem]?.lineSAPName}}
                        </span>
                    </div>

                    <div class="fw quantity-dtls-table-wrapper">
                        <div class="fw table-header">
                            <div class="cell total">
                                <span>{{'common.total' | translate}}</span>
                            </div>
                            <div class="cell rm" *ngIf="showRM">
                                <span>{{'common.rm' | translate}}</span>
                            </div>
                            <div class="cell pm" *ngIf="showPM">
                                <span>{{'common.pm' | translate}}</span>
                            </div>
                            <div class="cell total"
                                *ngIf="showInGraph.isStock &&  this.selectedType!=='line' && this.selectedType!=='linetosku' && selectedType!=='sku'">
                                <span>Adjusted RM </span>
                            </div>
                            <div class="cell rm"
                                *ngIf="showInGraph.isStock && this.selectedType!=='line' && this.selectedType!=='linetosku' && selectedType!=='sku'">
                                <span>Adjusted PM</span>
                            </div>
                            <div class="cell pm"
                                *ngIf="showInGraph.isStock && showInGraph.sfg && this.selectedType!=='line' && this.selectedType!=='linetosku'">
                                <span>Adjusted SFG</span>
                            </div>
                            <div class="cell pm"
                                *ngIf="showInGraph.isStock &&  this.selectedType!=='line' && this.selectedType!=='linetosku'">
                                <span>Adjusted FG</span>
                            </div>

                        </div>
                        <div class="component-type"
                            *ngFor="let unit of popOverArr[hoveredItem]?.quantityWaste;let j=index;">
                            <ng-container>
                                <div class="label ellipses cell">
                                    <div class="unit {{unit?.unit}}"> {{unit.unitValue}} </div>
                                </div>
                                <div class="cell total val">
                                    {{unit.totalValue | localDecimalPipe}}
                                </div>
                                <div class="cell rm val" *ngIf="showRM">
                                    {{unit.rmValue | localDecimalPipe}}
                                </div>
                                <div class="cell pm val" *ngIf="showPM">
                                    {{unit.pmValue | localDecimalPipe}}
                                </div>
                                <div class="cell total val"
                                    *ngIf="showInGraph.isStock && this.selectedType!=='line' && this.selectedType!=='linetosku' && selectedType!=='sku'">
                                    {{unit.adjRM | localDecimalPipe}}
                                </div>
                                <div class="cell total val"
                                    *ngIf="showInGraph.isStock && this.selectedType!=='line' && this.selectedType!=='linetosku' && selectedType!=='sku'">
                                    {{unit.adjPM | localDecimalPipe}}
                                </div>
                                <div class="cell total val"
                                    *ngIf="showInGraph.isStock && showInGraph.sfg && this.selectedType!=='line' && this.selectedType!=='linetosku'">
                                    {{unit.adjSFG | localDecimalPipe}}
                                </div>
                                <div class="cell total val"
                                    *ngIf="showInGraph.isStock && this.selectedType!=='line' && this.selectedType!=='linetosku'">
                                    {{unit.adjFG | localDecimalPipe}}
                                </div>
                            </ng-container>
                        </div>

                        <div class="no-data-hovered"
                            *ngIf="popOverArr[hoveredItem]?.quantityWaste && popOverArr[hoveredItem]?.quantityWaste.length === 0">
                            {{'waste_db.no_waste' | translate}}
                        </div>
                    </div>

                </div>
            </ng-template>
        </div>

    </div>
    <div *ngIf="!(plotData && plotData?.length > 0 && plotData[0].quantity &&  plotData[0].quantity.length > 0 && plotData[0].quantity[0].qty && plotData[0].quantity[0].qty.length > 0) && !isLoading"
        class="fw no-data fh">
        <div class="info-wrapper">
            <div class="smiley">
            </div>
            <div class="bold">
                <span> {{'waste_db.no_waste' | translate}}</span>
            </div>
            <div class="sub-info">
                <span> {{'waste_db.no_waste_desc' | translate}}</span>
            </div>
        </div>
    </div>